import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { Input } from "reactstrap";
import {
  GetAllClientsListPayloadType,
  GetAllUserOfSingleClientListPayloadType,
  UnassignedUserOfSingleClient,
} from "../../../commonTypes/authTypes";
import {
  CommonHeader,
  ErrorSuccessModal,
  Loader,
  ToggleSwitch,
} from "../../../components/commons";
import useDebounce from "../../../customHooks/useDebounce";
import {
  getAllAssignUserOfSingleClientAction,
  getAllClientsAction,
  resetAllAssignUserOfSingleClient,
  resetAuthError,
  resetAuthSuccess,
  resetSession,
  unassignedUserOfSingleClient,
} from "../../../redux/auth";
import {
  ClientType,
  GetAllAssignUserOfSingleClient,
} from "../../../redux/auth/authTypes";
import { RootState } from "../../../redux/rootReducers";
import { GetClientDirectoryListPayloadType } from "../../../commonTypes/clientDirectoryTypes";
import {
  getClientDirectoryListAction,
  resetClientDirectoryError,
  resetClientDirectoryMessage,
  resetClientDirectoryStatusCode,
  resetClientDirectorySuccess,
} from "../../../redux/clientDirectory";
import { ClientDirectoryListType } from "../../../redux/clientDirectory/clientDirectoryType";
type AppProps = {
  token: string | null;
  error: string | null;
  history?: any;
  authError: string | null;
  success: number | null;
  authStatusCode: number | null;
  authSuccess: number | null;
  statusCode: number | null;
  dispatchGetAllClientsAction: (data: GetAllClientsListPayloadType) => void;
  dispatchUnassignedUserOfSingleClient: (
    data: UnassignedUserOfSingleClient
  ) => void;
  dispatchResetAllAssignUserOfSingleClient: () => void;
  dispatchResetAuthError: () => void;
  dispatchResetAuthSuccess: () => void;
  dispatchResetSession: () => void;
  dispatchGetClientDirectoryListAction: (
    data: GetClientDirectoryListPayloadType
  ) => void;
  dispatchGetAllAssignUserOfSingleClientAction: (
    data: GetAllUserOfSingleClientListPayloadType
  ) => void;
  clientDirectoryList: [] | ClientDirectoryListType[];
  activeTab: string;
  allAssignUserOfSingleClient: GetAllAssignUserOfSingleClient;
  fetching: boolean;
  totalCount: any;
  searchData?: string;
  clientDirectoryFetching?: boolean;
  dispatchResetClientDirectorySuccess: () => void;
  dispatchResetClientDirectoryError: () => void;
  dispatchResetClientDirectoryMessage: () => void;
  dispatchResetClientDirectoryStatusCode: () => void;
};

type ClientListType = {
  value: number | undefined | null;
  label: string | null;
};

const ExternalUserOfClient = ({
  token,
  statusCode,
  success,
  authSuccess,
  authStatusCode,
  fetching,
  totalCount,
  activeTab,
  authError,
  clientDirectoryFetching,
  clientDirectoryList,
  error,
  searchData,
  dispatchGetAllClientsAction,
  dispatchGetClientDirectoryListAction,
  dispatchGetAllAssignUserOfSingleClientAction,
  allAssignUserOfSingleClient,
  dispatchResetAllAssignUserOfSingleClient,
  dispatchUnassignedUserOfSingleClient,
  dispatchResetAuthError,
  dispatchResetAuthSuccess,
  dispatchResetClientDirectorySuccess,
  dispatchResetClientDirectoryError,
  dispatchResetClientDirectoryMessage,
  dispatchResetClientDirectoryStatusCode,
  dispatchResetSession,
}: AppProps) => {
  const [clientId, setClientId] = useState<any>(null);
  const [userId, setUserId] = useState<any[] | []>([]);
  const [limit, setLimit] = useState(20);
  const [offset, setOffset] = useState(0);
  const [finalClientList, setFinalClientList] = useState<ClientListType[] | []>(
    []
  );
  const [clientSelected, setClientSelected] = useState<ClientListType>({
    value: null,
    label: "Select Client...",
  });
  const [text, setText] = useState<string>("");
  const [loadCondition, setLoadCondition] = useState(true);
  const [unassignedAll, setUnassignedAll] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [unassignedUsersList, setUnassignedUsersList] = useState<any[]>([]);

  useEffect(() => {
    dispatchResetAuthSuccess();
    dispatchResetAuthError();
    dispatchResetClientDirectorySuccess();
    dispatchResetClientDirectoryError();
    dispatchResetClientDirectoryMessage();
    dispatchResetClientDirectoryStatusCode();
    if (token) {
      if (offset <= +totalCount) {
        const finalList = {
          token,
          status: 1,
          offset,
          limit,
          searchValue: text,
        };
        // dispatchGetAllClientsAction(finalList)
        dispatchGetClientDirectoryListAction(finalList);
      }
    }
  }, [offset]);

  const fetchNewData = () => {
    if (token) {
      const finalData = {
        token,
        offset,
        limit,
        searchValue: text,
      };

      dispatchGetClientDirectoryListAction(finalData);
    }
  };


  useDebounce(
    () => {
        fetchNewData()
    },
    500,
    [text]
  );

  useEffect(() => {
    if (clientDirectoryList?.length) {
      if (offset <= +totalCount) {
        let finalClientData = clientDirectoryList?.map((e: any) => {
          return {
            value: e?.client_code,
            label: `(${e?.client_code}) ${e?.company_name}`,
          };
        });
        if (offset > 0) {
          setFinalClientList([...finalClientList, ...finalClientData]);
        } else {
          setFinalClientList([...finalClientData]);
        }
      }
    }
  }, [clientDirectoryList]);

  useEffect(() => {
    const totalUserIds = allAssignUserOfSingleClient?.data?.map(
      (e: any) => e?.user_id
    );
    setUserId(totalUserIds);
  }, [allAssignUserOfSingleClient?.data]);

  useEffect(() => {
    if (unassignedAll) {
      const totalUserIds = allAssignUserOfSingleClient?.data?.map(
        (e: any) => e?.user_id
      );
      setUserId([]);
      setUnassignedUsersList(totalUserIds);
    } else {
      const totalUserIds = allAssignUserOfSingleClient?.data?.map(
        (e: any) => e?.user_id
      );
      setUserId(totalUserIds);
      setUnassignedUsersList([]);
    }
  }, [unassignedAll]);

  const checkBottom = (e: any) => {
    setLoadCondition(false);
    setOffset((prv) => prv + limit);
  };
  const onMenuClose = () => setLoadCondition(true);

  const handleChangeClient = (client: any) => {
    dispatchResetAllAssignUserOfSingleClient();
    setClientId(client?.value);
    setClientSelected(client);

    if (client) {
      const finalList = {
        token,
        client_code: client.value,
        user_type: activeTab === "External_User" ? 2 : 1,
      };
      dispatchGetAllAssignUserOfSingleClientAction(finalList);
    }
  };

  useDebounce(
    () => {
      if (searchValue) {
        const finalList = {
          token,
          client_code: clientId,
          search_term: searchValue,
        };
        dispatchGetAllAssignUserOfSingleClientAction(finalList);
      } else {
        const finalList = {
          token,
          client_code: clientId,
        };
        if (clientId) {
          dispatchGetAllAssignUserOfSingleClientAction(finalList);
        }
      }
    },
    500,
    [searchValue]
  );

  const handleSearchUser = (event: any) => {
    let value = event.target.value;
    if (value?.length > 0) {
      setSearchValue(value);
    } else {
      setSearchValue("");
    }
  };
  const handleRemoveUserId = (id: number, set: string) => {
    if (set === "set") {
      setUnassignedUsersList((prev) => [...prev, id]);
    } else {
      let arr = unassignedUsersList?.filter((e) => e !== id);
      setUnassignedUsersList([...arr]);
    }

    let oldUserIdList = [...userId];
    let newUserIdList: any[] = [];
    let isUserId = oldUserIdList?.find((e) => e === id);
    if (isUserId) {
      newUserIdList = oldUserIdList?.filter((e: number) => e !== id);
    } else {
      newUserIdList = [...oldUserIdList, id];
    }
    setUserId(newUserIdList);
  };

  const renderUserList = () => {
    let count = 0;
    let userList =
      searchValue?.length > 0
        ? allAssignUserOfSingleClient?.data?.map((user: any) => {
            if (user?.user_type == 2) {
              count++;
              let assignedId = userId?.find((e) => e === user?.user_id);
              return (
                <li key={user?.user_id}>
                  <>
                    <Input
                      type="checkbox"
                      onChange={() => {
                        handleRemoveUserId(
                          user?.user_id,
                          assignedId ? "set" : "remove"
                        );
                      }}
                      checked={!!assignedId}
                      className="pointer"
                    />
                    {`(${user?.user_id}) ${user?.first_name} ${user?.last_name}`}
                  </>
                </li>
              );
            }
            return null;
          })
        : allAssignUserOfSingleClient?.data?.map((user: any) => {
            // let count= 0
            if (user.user_type == 2) {
              count++;
              let assignedId = userId?.find((e) => e === user?.user_id);
              return (
                <li key={user?.user_id}>
                  <>
                  <Input
                    type="checkbox"
                    className="pointer"
                    onChange={() => {
                      handleRemoveUserId(
                        user?.user_id,
                        assignedId ? "set" : "remove"
                        );
                      }}
                      checked={!!assignedId}
                      />
                  {`(${user?.user_id}) ${user?.first_name} ${user?.last_name}`}
                      </>
                </li>
              );
            }
            return null;
          });

    return userList;
  };

  const handleUnassignUser = () => {
    setSearchValue("");
    setUnassignedUsersList([]);
    setClientId(null);
    if (token && userId) {
      const finalData = {
        token,
        clientId,
        userId: unassignedUsersList,
      };
      dispatchUnassignedUserOfSingleClient(finalData);
    }
  };

  const handleResetData = () => {
    setClientSelected({
      value: null,
      label: "Select Client...",
    });
    setClientId(null);
  };

  const handleToggleIsUnassignedAll = () => {
    setUnassignedAll(!unassignedAll);
  };

  const handleErrorModal = () => {
    if (success === 0 || authSuccess === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (authStatusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!authError}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetAuthError();
            }}
          />
        );
      }
    }
    if (authSuccess === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message="Users Unassigned Successfully!"
          buttonText="OK"
          onPress={() => {
            dispatchResetAuthSuccess();
            handleResetData();
          }}
          statusCode={statusCode}
        />
      );
    }

    return false;
  };

  return (
    <div className="row ml-1">
      <div className="col-md-5 mt-3">
        <h3 className="mb-3">Choose Client</h3>
        <Select
          value={clientSelected}
          cacheOptions
          options={finalClientList}
          onChange={handleChangeClient}
          onMenuScrollToBottom={(e: any) => checkBottom(e)}
          onInputChange={(e: string) => {
            setLoadCondition(false);
            setText(e);
            setOffset(0);
            setUnassignedAll(false);
          }}
          onMenuClose={onMenuClose}
          isLoading={!loadCondition && clientDirectoryFetching}
        />
      </div>
      <div className="col-md-7 mt-3">
        <h3 className="mb-3">Assigned External User List</h3>
        <div className="form-group">
          <div className="d-flex justify-content-start">
            <input
              type="text"
              className="form-control search-client-input w-50"
              placeholder="Search user..."
              value={searchValue}
              onChange={(e) => handleSearchUser(e)}
              disabled={!clientId}
            />
          </div>
        </div>
        <div className="client-container">
          {/* {clientId && !!allAssignUserOfSingleClient?.data?.length && <ul className="column-list">
                   <Input
                        type="checkbox"
                        className='pointer'
                        onChange={() => handleToggleIsUnassignedAll()}
                        checked={unassignedAll}
                    />
                        <span style={{marginTop:"-2px", fontSize:"15px",fontWeight:'500'}}>Unselect All</span>
                    </ul>} */}
          {clientId ? (
            <ul className="column-list">{renderUserList()}</ul>
          ) : (
            <span>Please Choose Client...</span>
          )}
          {!allAssignUserOfSingleClient?.data?.length && clientId && (
            <span>No Assigned users is there</span>
          )}
        </div>
        <button
          className="btn btn-primary mt-4 mb-4 pointer"
          onClick={handleUnassignUser}
          style={{ width: "50%" }}
          disabled={!clientId}
        >
          Unassign
        </button>
      </div>
      {fetching && offset === 0 && <Loader />}
      {handleErrorModal()}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  allAssignUserOfSingleClient: state.auth.allAssignUserOfSingleClient,
  success: state.clientDirectory.success,
  fetching: state.auth.fetching,
  authSuccess: state.auth.success,
  clientDirectoryFetching: state.clientDirectory.fetching,
  message: state.clientDirectory.message,
  statusCode: state.clientDirectory.statusCode,
  authStatusCode: state.auth.statusCode,
  error: state.clientDirectory.error,
  authError: state.auth.error,
  clientDirectoryList: state.clientDirectory.clientDirectoryList,
  totalCount: state.clientDirectory.totalCount,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetAllClientsAction: (data: any) =>
    dispatch(getAllClientsAction(data)),
  dispatchUnassignedUserOfSingleClient: (data: UnassignedUserOfSingleClient) =>
    dispatch(unassignedUserOfSingleClient(data)),
  dispatchResetAllAssignUserOfSingleClient: () =>
    dispatch(resetAllAssignUserOfSingleClient()),
  dispatchGetAllAssignUserOfSingleClientAction: (
    data: GetAllUserOfSingleClientListPayloadType
  ) => dispatch(getAllAssignUserOfSingleClientAction(data)),
  dispatchResetAuthError: () => dispatch(resetAuthError()),
  dispatchResetAuthSuccess: () => dispatch(resetAuthSuccess()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchGetClientDirectoryListAction: (
    data: GetClientDirectoryListPayloadType
  ) => dispatch(getClientDirectoryListAction(data)),
  dispatchResetClientDirectorySuccess: () =>
    dispatch(resetClientDirectorySuccess()),
  dispatchResetClientDirectoryError: () =>
    dispatch(resetClientDirectoryError()),
  dispatchResetClientDirectoryMessage: () =>
    dispatch(resetClientDirectoryMessage()),
  dispatchResetClientDirectoryStatusCode: () =>
    dispatch(resetClientDirectoryStatusCode()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExternalUserOfClient);
